import React from 'react';
import { useTranslation } from 'react-i18next';
import './RegistrationPromptModal.css'; // Добавьте стили для модального окна
import './AuthForm.css';
import './UserSettings.css';

const RegistrationPromptModal = ({ onClose }) => {
  const { t } = useTranslation();

  const handleRegisterClick = () => {
    window.location.href = '/auth'; // Редирект на страницу входа/регистрации
  };

  return (
    <div className="registration-prompt__overlay" onClick={onClose}>
      <div className="registration-prompt__container" onClick={e => e.stopPropagation()}>
        <button className="registration-prompt__close" onClick={onClose}>×</button>
        <h2>{t('registrationPrompt.title')}</h2>
        <p>{t('registrationPrompt.desc')}</p>
        <div className="registration-prompt__buttons">
          <button onClick={handleRegisterClick} className="authform__button">{t('registrationPrompt.register')}</button>
          <button onClick={onClose} className="registration-prompt__text-button">{t('registrationPrompt.notNow')}</button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPromptModal;
